/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUtilizationMetric {
    getFixupPrototypeFunction() { return ResourceUtilizationMetric.fixupPrototype; }

    static newInstance(model: Partial<ResourceUtilizationMetric>): ResourceUtilizationMetric {
        let obj = Object.assign(new ResourceUtilizationMetric(), model);
        ResourceUtilizationMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUtilizationMetric>): ResourceUtilizationMetric {
        if (!model) return null;
        return ResourceUtilizationMetric.newInstance(<ResourceUtilizationMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUtilizationMetric) {
        if (!obj) return;

        models.ResourceUtilizationMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUtilizationMetric): boolean {
        Object.setPrototypeOf(obj, ResourceUtilizationMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.timeseries) {
            for (let val of this.timeseries) {
                models.TimeSeriesPoint.fixupPrototype(val);
            }
        }
    }

    /**
     * Unit of the metric
     */
    unit: string;

    /**
     * Name of the metric
     */
    metric_name: string;

    timeseries: Array<models.TimeSeriesPoint>;

}
